// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    
export class LaborByLevel {
  levelID: number;
  levelDescription: string;
  laborType: string;
  servicingOffice: string;
  standardRate: number;
  baseHours: number;
  adjustmentHours: number;
  hoursTotal: number;
  otpwr: string;
  costTotal: number;
  typicalOfCount: string;
  systemDifficultyLevel: string;
}
